import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import javaScript from "../assets/techStack/logo-javascript.svg";
import typeScript from "../assets/techStack/typescript.svg";
import reactJs from "../assets/techStack/react.svg";
import nextJS from "../assets/techStack/nextJs.svg";
import nodeJs from "../assets/techStack/nodejs-icon.svg";
import expressJs from "../assets/techStack/ex1.png";
import mongoDB from "../assets/techStack/mongodb.svg";
import mySql from "../assets/techStack/mysql-logo.svg";
import aws from "../assets/techStack/aws-2.svg";
import figma from "../assets/techStack/figma-5.svg";

const logos = [
  {
    src: javaScript,
    name: "JavaScript",
  },
  {
    src: typeScript,
    name: "TypeScript",
  },
  {
    src: reactJs,
    name: "React JS",
  },
  {
    src: nextJS,
    name: "Next JS",
  },
  {
    src: nodeJs,
    name: "Node JS",
  },
  {
    src: expressJs,
    name: "Express JS",
  },
  {
    src: mongoDB,
    name: "mongoDB",
  },
  {
    src: mySql,
    name: "MySQL",
  },
  {
    src: aws,
    name: "AWS",
  },
  {
    src: reactJs,
    name: "React Native",
  },
  {
    src: figma,
    name: "Figma",
  },
];

const logoStyle = {
  width: "100px",
  height: "80px",
  margin: "0 32px",
};

export default function TechStack() {
  return (
    <Box id="techStack" sx={{ py: 4 }}>
      <Typography
        component="h2"
        align="center"
        variant="h4"
        color="text.primary"
        mb={2}
      >
        Our technical forte
      </Typography>
      <Grid container justifyContent="center" sx={{ mt: 0.5 }}>
        {logos.map((logo, index) => (
          <Grid item key={index}>
            <img
              src={logo?.src}
              alt={`logo for ${logo?.name}`}
              style={logoStyle}
            />
            <Typography textAlign="center">{logo?.name}</Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
